import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../components/index";
import { Button, Grid, Typography, Card, CardContent, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import DescriptionIcon from "@mui/icons-material/Description";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { StoreContext } from "../../App";
import { Page } from "../../components";

const Forms = observer(() => {
  const { auth } = useContext(StoreContext);
  const user = auth.user;

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Page title="«Електронні форми»">
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: 2 }}>
            <Card elevation={2} sx={{ maxWidth: 900, mx: "auto" }}>
              <CardContent sx={{ textAlign: "center" }}>
                <Typography variant={"h6"} component={"h1"} sx={{ fontWeight: 500 }}>
                  Проведення конкурсного відбору при заміщенні вакантних посад науково-педагогічних працівників SUITT
                </Typography>
                <Stack spacing={1.5} alignItems={"center"} sx={{ mt: 2 }}>
                  <Button size={"large"} variant={"contained"} component={Link} to={`/cabinet/users/${user?._id}`} sx={{ width: { xs: "100%", sm: 420 } }}>
                    Електронні форми у форматі ЄДЕБО
                  </Button>
                  <Button size={"large"} variant={"outlined"} component={"a"} target={"_blank"}
                          endIcon={<OpenInNewIcon />}
                          href={`/static/files/%D0%86%D0%BD%D1%81%D1%82%D1%80%D1%83%D0%BA%D1%86%D1%96%D1%97%20%D1%82%D0%B0%20%D1%80%D0%B5%D0%BA%D0%BE%D0%BC%D0%B5%D0%BD%D0%B4%D0%B0%D1%86%D1%96%D1%97%20%D0%B2%D0%B8%D0%BA%D0%BB%D0%B0%D0%B4%D0%B0%D1%87%D0%B0%D0%BC.pdf`}
                          sx={{ width: { xs: "100%", sm: 420 } }}>
                    Інструкція по використанню
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: 2 }}>
            <Card elevation={2} sx={{ maxWidth: 900, mx: "auto" }}>
              <CardContent sx={{ textAlign: "center" }}>
                <Typography variant={"h6"} component={"h1"} sx={{ fontWeight: 500 }}>
                  Інформаційне наповнення сайту SUITT
                </Typography>
                <Stack spacing={1.5} alignItems={"center"} sx={{ mt: 2 }}>
                  <Button size={"large"} variant={"contained"} component={Link} to={"/cabinet/forms/suitt"} sx={{ width: { xs: "100%", sm: 420 } }}>
                    Форми надання інформації для сайту SUITT
                  </Button>
                  <Button size={"large"} variant={"outlined"} component={"a"} target={"_blank"}
                          endIcon={<DescriptionIcon />}
                          href={`/static/files/%D0%86%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%86%D1%96%D0%B9%D0%BD%D0%B5_%D0%BD%D0%B0%D0%BF%D0%BE%D0%B2%D0%BD%D0%B5%D0%BD%D0%BD%D1%8F_%D1%81%D0%B0%D0%B9%D1%82%D1%83_%D0%94%D0%A3%D0%86%D0%A2%D0%97.pdf`}
                          sx={{ width: { xs: "100%", sm: 420 } }}>
                    Інструкція по використанню
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Page>
    </ErrorBoundary>
  );
});


export default Forms;
